<template>
  <OverviewV2 v-if="useV2" />
  <OverviewLegacy v-else />
</template>

<script>
// Nouvel overview : partout hors prod, en prod pour les comptes de la bêta (utils/overviewAccess)
import { overviewV2Enabled } from '@/utils/overviewAccess'

export default {
  name: 'overview',

  // Chargés à la demande : la version non utilisée n'est jamais téléchargée
  components: {
    OverviewV2: () => import('./OverviewV2.vue'),
    OverviewLegacy: () => import('./OverviewLegacy.vue')
  },

  computed: {
    useV2() {
      return overviewV2Enabled(this.$store.getters['users/getCurrentUser'])
    }
  }
}
</script>
